/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/close-circle': {
    width: 23,
    height: 23,
    viewBox: '0 0 23 23',
    data: '<rect pid="0" width="22.076" height="22.076" rx="11.038" _fill="#2D322E"/><path pid="1" _fill="#fff" d="M6.622 7.84l.892-.892 8.028 8.028-.892.892z"/><path pid="2" _fill="#fff" d="M14.65 6.947l.892.891-8.028 8.028-.891-.891z"/>'
  }
})
